module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('app-header', {
    staticClass: "animated fadeIn"
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ed3de8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 150
// module chunks = 0